import React, { useState, useEffect, useRef } from "react";
import { slide as Menu } from "react-burger-menu";
import { Link, useLocation } from "react-router-dom";
import "./MenuComponent.css";

const MenuComponent = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const location = useLocation();

  // Fecha o menu ao clicar fora
  const handleOutsideClick = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  // Fecha menu ao navegar
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  useEffect(() => {
    if (isMenuOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isMenuOpen]);

  const isActive = (path) => {
    return (
      location.pathname === path ||
      location.pathname === path.replace("home", "")
    );
  };

  return (
    <div ref={menuRef}>
      <header className="container">
        <Link to="/home" className="tituloMenuComponent">
          <div className="logo">
            <img src="/images/moeda.png" alt="conversor logo" />
            <span>Conversor de Moedas</span>
          </div>
        </Link>

        <Menu
          right
          noOverlay
          disableAutoFocus
          isOpen={isMenuOpen}
          onStateChange={({ isOpen }) => setIsMenuOpen(isOpen)}
        >
          <ul className="lista">
            <li>
              <Link
                to="/home"
                style={{
                  backgroundColor:
                    isActive("/home") || isActive("/")
                      ? "#f0f0f0"
                      : "transparent",
                  color:
                    isActive("/home") || isActive("/") ? "#667eea" : "#2c3e50",
                }}
              >
                🏠 Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                style={{
                  backgroundColor: isActive("/about")
                    ? "#f0f0f0"
                    : "transparent",
                  color: isActive("/about") ? "#667eea" : "#2c3e50",
                }}
              >
                ℹ️ About
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                style={{
                  backgroundColor: isActive("/contact")
                    ? "#f0f0f0"
                    : "transparent",
                  color: isActive("/contact") ? "#667eea" : "#2c3e50",
                }}
              >
                ✉️ Contact
              </Link>
            </li>
            <li>
              <Link
                to="/api"
                style={{
                  backgroundColor: isActive("/api") ? "#f0f0f0" : "transparent",
                  color: isActive("/api") ? "#667eea" : "#2c3e50",
                }}
              >
                ⚙️ API
              </Link>
            </li>
          </ul>
        </Menu>
      </header>
    </div>
  );
};

export default MenuComponent;
